module.exports = __webpack_public_path__ + "static/img/zhengshu4.37e8ca3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhengshu4.png
// module id = Jab3
// module chunks = 1